export default "__VITE_ASSET__BeB4KXyx__"